"use client";

import { Pencil } from "lucide-react";
import Link from "next/link";
import { authClient } from "@/features/auth/shared/client";

export function AdminEditButton({ companyId }: { companyId: string }) {
  const { data: session, isPending } = authClient.useSession();
  if (isPending || !session) return null;

  return (
    <Link
      href={`/admin/firmaer/${companyId}`}
      className="inline-flex items-center gap-1.5 rounded bg-theme px-3 py-1.5 text-xs font-medium uppercase tracking-[0.04em] text-white hover:bg-theme-dark"
    >
      <Pencil className="h-3.5 w-3.5" aria-hidden="true" />
      Rediger
    </Link>
  );
}
